import Aos from "aos";
import { motion } from "framer-motion";
import { useEffect } from "react";

const services = [
  {
    title: "MERN Applications",
    desc: "End-to-end scalable web applications using MongoDB, Express, React & Node.",
  },
  {
    title: "Admin Dashboards",
    desc: "Role-based dashboards for Admin, Manager & Users with full control.",
  },
  {
    title: "Analytics & Reports",
    desc: "Interactive admin analytics using Recharts (loan status, revenue, user activity).",
  },
  {
    title: "Authentication Systems",
    desc: "JWT & Firebase authentication with protected routes and role authorization.",
  },
  {
    title: "Payment Integration",
    desc: "Secure payment systems using Stripe for application fees and transactions.",
  },
  {
    title: "Modern UI / UX",
    desc: "Clean, responsive & animated UI using Tailwind CSS and Framer Motion.",
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.1,
      type: "spring",
      stiffness: 120,
    },
  }),
};
 

const WhatIBuild = () => {
   /*  useEffect(() => {
      Aos.init({});
    }, []); */
  return (
    <section className="container mx-auto px-6 py-20">
      <motion.h2
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-4xl md:text-5xl font-bold text-center text-lime-500 mb-14"
      >
        What I Build
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((item, i) => (
          <motion.div
            key={i}
           /*  data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-once="false"
            data-aos-mirror="true" */
            custom={i}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            whileHover={{ scale: 1.05 }}
            className="bg-gradient-to-br from-gray-700 to-lime-900 p-6 rounded-xl shadow-lg cursor-pointer"
          >
            <h3 className="text-xl font-bold text-lime-400 mb-3">
              {item.title}
            </h3>
            <p className="text-sm text-gray-200 leading-relaxed">{item.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default WhatIBuild;
